export default __webpack_public_path__ + "static/media/FOTO9.87d183bd.jpg";